import React, { useState, useEffect } from 'react'

import {
    Input,
    Card,
    Avatar,
    Skeleton
} from 'antd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPollH,
    faTimesCircle,
    faArrowCircleDown,
    faSync,
    faSlidersH,
    faBalanceScale,
    faShareAlt
} from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import { StaticImage } from '../../../utils/image';
import { ConvertDateShort } from '../../../utils/date';
import { checkComplete, checkLeftTime, checkLeftTimeIcon, checkLeftTimeStatus } from '../../../utils';
import ProgressBar from "../../listeningV2/progressBar";
import { useHistory } from 'react-router-dom';
import { encodeBase64 } from '../../../utils/convertBase64';
import TagDuoTone from '../../iconComponent/TagDuoTone';
import './index.scss'

const SurveyCardItem = ({ survey, law_group, handleFavorite, setShowShare }) => {
    const history = useHistory();
    const [isCollapse, setIsCollapse] = useState(false);
    const renderImageLawGroup = (item) => {
        let law = "";
        if (item.law_group_id) {
            const split = item.law_group_id.split(",");
            law = law_group.find((x) => x.lawgroup_id == split[0]);
        }

        return (
            <div className="law-group-container-mobile d-flex-center" style={{ marginRight: 15 }}>
                <div className="d-flex-center">
                    {law && law.image ? (
                        <Avatar
                            className="avatar-object-contain"
                            size={{
                                xs: 24,
                                sm: 24,
                                md: 24,
                                lg: 24,
                                xl: 24,
                                xxl: 24,
                            }}
                            style={{
                                height: 24,
                                width: 24,
                            }}
                            // shape={'circle'}
                            src={law.image}
                        />
                    ) : (
                        <Skeleton.Button active={true} size={24} shape={"circle"} />
                    )}
                </div>
            </div>
        );
    };
    const renderLawGroupText = (item) => {
        let law = "ไม่ได้ระบุ";
        if (item.law_group_id) {
            const split = item.law_group_id.split(",");
            law = law_group.filter((x) => split.includes(x.lawgroup_id.toString()));
            law = law.length > 0 ? law.map(x => x.lawgroup_name).join(',') : "-";
        }

        return (
            <div
                className="d-flex discuss-container"
                style={{ marginRight: 15, alignItems: 'flex-start' }}
            >
                <img
                    src={StaticImage("/images/icon/books-duotone-1-copy.svg")}
                    style={{ marginRight: 5 }}
                    alt="webboard"
                    height={18}
                />
                <label className="lawgroup-text" style={{ color: "#333", textOverflow: 'initial', maxWidth: 'none', whiteSpace: 'break-spaces' }}>
                    {law}
                </label>
            </div>
        );
    };
    const renderAnswerCount = (survey) => {
        let answer_count = survey.answer_count ?? 0;
        return (
            <div className="d-flex discuss-container" style={{ marginRight: 15 }}>
                <div className="badge-answer">{answer_count}</div>
            </div>
        );
    };
    const renderPublishNo = (survey) => {
        return (
            <div className="d-flex discuss-container" style={{ paddingRight: 7.5 }}>
                <img
                    src={StaticImage("/images/icon/pen-nib-duotone.svg")}
                    style={{ marginRight: 5 }}
                    height={24}
                    alt="public-no"
                />
                <div className="d-flex" style={{ alignItems: 'center' }}>
                    <span>ครั้งที่</span>
                    <div className="badge-public">{survey.publish_no}</div>
                </div>
            </div>
        );
    };

    const collapse = (e, item) => {
        e.stopPropagation();
        setIsCollapse(!isCollapse);
    };

    const navigate = (survey_id) => {
        history.push(`/listeningDetail?survey_id=${encodeBase64(survey_id)}`);
    }

    const renderFavorite = (survey) => {
        return (
            survey.is_like === true ? (
                <img
                    height={32}
                    width={32}
                    src={StaticImage(
                        "/images/icon/header/heart-circle-duotone-2-active.svg"
                    )}
                    alt="favorite"
                />
            ) : (
                <img
                    height={32}
                    width={32}
                    className="cursor-pointer"
                    onMouseOver={(e) =>
                    (e.currentTarget.src = StaticImage(
                        "/images/icon/header/heart-circle-duotone-2-active.svg"
                    ))
                    }
                    onMouseOut={(e) =>
                    (e.currentTarget.src = StaticImage(
                        "/images/icon/header/heart-circle-duotone-2.svg"
                    ))
                    }
                    src={StaticImage(
                        "/images/icon/header/heart-circle-duotone-2.svg"
                    )}
                    alt="favorite"
                />
            )
        );
    }

    const renderDate = () => {
        return (
            <div className="d-flex-align-center" style={{ marginRight: 20 }}>
                <img
                    src={StaticImage(checkLeftTimeIcon(survey) ? "/images/icon/vote-yea-duotone.svg" : "/images/icon/vote-nay-duotone.svg")}
                    style={{ marginRight: 5 }}
                    height={16}
                    alt="public-no"
                />
                <div className="d-flex" style={{ alignItems: 'center' }}>
                    <span>
                        {`${ConvertDateShort(survey.start_date, "DD MMM YY")} - ${ConvertDateShort(survey.end_date, "DD MMM YY")}`}
                    </span>
                </div>
            </div>
        );
    };
    const renderStatus = () => {
        return (
            checkLeftTimeStatus(survey)
        );
    };



    return (
        <section>
            <div className="survey-card" onClick={() => navigate(survey.survey_id)}>
                <div className="d-flex row1" style={{ flexWrap: 'wrap' }}>
                    <div className="d-flex-align-center flex-1">
                        {renderImageLawGroup(survey)}
                        {survey.agency_id > 0 && (
                            <div
                                className="organize-container"
                                style={{ margin: 0, marginRight: 15 }}
                            >
                                <img
                                    alt="agency_image"
                                    src={survey.agency_image_uploaded ?? survey.agency_image}
                                    className="logo"
                                    oncontextmenu="return false;"
                                    onError={(i) => (i.target.style.display = "none")}
                                />
                                <label className='line-clamp-2' style={{ paddingLeft: "2px" }}>
                                    {survey.agency_short ?? survey.agency_abbrv}
                                </label>
                            </div>
                        )}
                        <div className="project-type">
                            <TagDuoTone />
                            <span>
                                {survey.survey_type_name}
                            </span>
                        </div>

                    </div>
                    <div className='d-flex'>
                        <button
                            type="button"
                            className="survey-card-action-button"
                            aria-label="แชร์การรับฟังนี้"
                            onClick={() => setShowShare(true)}
                            style={{ marginRight: 10, marginTop: 2 }}
                        >
                            <FontAwesomeIcon
                                className='share-icon cursor-pointer'
                                style={{ width: 20, height: 28, marginRight: 10 }}
                                color='#6d7481'
                                icon={faShareAlt}
                            />
                        </button>
                        <button
                            type="button"
                            className="survey-card-action-button"
                            aria-label={`${survey.is_like === true ? 'ยกเลิกถูกใจ' : 'ถูกใจ'}การรับฟังนี้`}
                            onClick={(e) => handleFavorite(e, survey)}
                        >
                            <div className="group relative py-2">
                                {renderFavorite(survey)}
                                <div className="hidden group-hover:block ...">ถูกใจ</div>
                            </div>
                        </button>
                    </div>

                </div>
                <div className="column2">
                    <div className="d-flex">
                        <label className="title flex-1">{survey.short_project_name ?? survey.project_name}</label>
                    </div>
                    <label className="description">
                        {survey.short_survey_name ?? survey.survey_name}
                    </label>
                    <div className="webboard-row">
                        {renderLawGroupText(survey)}
                    </div>
                    <div className="webboard-row" >
                        <div className="d-flex-align-center flex-1">
                            <div className="d-flex discuss-container">
                                <img
                                    src={StaticImage("/images/icon/users-class-light.svg")}
                                    style={{ marginRight: 10 }}
                                    alt="webboard"
                                />
                                <label style={{ color: "#488345" }}>
                                    ร่วมเสนอ
                                </label>
                            </div>
                            {renderAnswerCount(survey)}
                            {renderPublishNo(survey)}
                        </div>
                    </div>
                    <div className="progressbar-row">
                        <div style={{ display: "flex", flex: 1, paddingRight: 7.5 }}>
                            {checkLeftTimeIcon(survey) ? <>
                                <img
                                    src={StaticImage(checkLeftTimeIcon(survey) ? "/images/icon/vote-yea-duotone.svg" : "/images/icon/vote-nay-duotone.svg")}
                                    style={{ marginRight: 5 }}
                                    height={14}
                                    alt="public-no"
                                />
                                <span style={{ fontSize: 12 }}>
                                    {ConvertDateShort(survey.start_date, "DD MMM YY")}
                                </span>
                                <section
                                    className="progress-list-filter"
                                    style={{ width: "100%", maxWidth: 200 }}
                                >
                                    <ProgressBar
                                        bgcolor={survey.date_balance > 7 ? "#387436" : "#f96b57"}
                                        bgContainerColor={
                                            survey.date_balance > 7 ? "#e4e8f0" : "#e4e8f0"
                                        }
                                        leftTime={checkLeftTime(survey)}
                                        completed={checkComplete(survey)}
                                    />
                                </section>
                                <span>
                                    <span style={{ fontSize: 12 }}>
                                        {ConvertDateShort(survey.end_date, "DD MMM YY")}
                                    </span>
                                </span>
                            </>
                                :
                                <>
                                    {renderDate()}
                                    {renderStatus()}
                                </>
                            }

                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
}



export default SurveyCardItem;
